import { useEffect, useState } from 'react';
import MobileSideMenu from '../dashboard/sideMenu/MobileSideMenu';
import { useNavigate } from 'react-router-dom';
import {
  resetContactInfoSlice,
  resetManageAlertsSlice,
  resetRequest,
  signOutRequest,
  useContentfulStateData,
  useSecureDeviceId,
  resetOffersSlice,
  resetValidatePasscodeSlice,
  getChannelId,
  bankAccountDetailRequest,
  fetchRewardAccountRequest,
} from '@rb-serve-app/core';
import SecureLS from 'secure-ls';
import { useSelector } from 'react-redux';
import UnlinkRogersBenefits from '../../screens/UnlinkAccount';
import SuccessModel from '../../components/SuccessModel';
import { useDispatch } from 'react-redux';
import { RootState, unlinkAccountRequest } from '@rb-serve-app/core';
import CommanModal from '../../components/CommanModal';

type Props = {
  contentfulData?: any;
  contentSideNav?: any;
  featureFlaggingData: any;
  setShowFeatureFlagMessage: React.Dispatch<React.SetStateAction<boolean>>;
  isLinkAcc: any;
  isAccountRestricted: any;
  derogatoryData: any;
  isEppVisible: any;
  isPasskeyRegistered?: boolean;
};

const Header = ({
  contentfulData = {},
  contentSideNav = {},
  featureFlaggingData,
  setShowFeatureFlagMessage,
  isLinkAcc,
  isAccountRestricted,
  derogatoryData,
  isEppVisible,
  isPasskeyRegistered,
}: Props) => {
  const ls = new SecureLS({ encodingType: 'aes' });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { rememberMe, userName, accountId } = useSelector(
    (state: any) => state.user
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');
  const userDetails = ls.get('user');
  const deviceId = useSecureDeviceId();
  const { entries, assets } = useContentfulStateData();
  const { rb_contact_information } = entries;

  //unlink account
  const { contentfulData: contentful } = useSelector(
    (state: RootState) => state.contentful
  );

  const {
    nextLinkAttemptDate,
    rciAccountDetails,
    rciAccountStatus,
    linkingStatus,
    loading,
    status,
    detail,
    error,
  } = useSelector((state: RootState) => state.banLinkage);

  const { rb_roam_like_home, rb_links } = entries;
  const content = rb_roam_like_home?.rbUnlinkRogersBenefits;
  const eligibleContent = rb_roam_like_home?.rbRoamLikeHomeEligible;

  const [isUnlinkAccountPopup, setUnlinkAccountPopup] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isUnlinking, setIsUnlinking] = useState(false);
  const [canUnlink, setCanUnlink] = useState(false);
  const [linkageStatusText, setLinkageStatusText] = useState('');
  const [isUnlinkError, setIsUnlinkError] = useState(false);
  const [nextLinkageDate, setNextLinkageDate] = useState('');
  const handleOk = () => {
    setShowSuccessModal(false);
    setIsUnlinkError(false);
  };
  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  useEffect(() => {
    if (isUnlinking && !loading) {
      setIsUnlinking(false);
      console.log('Reaching here ---', error);
      if (
        linkingStatus === true ||
        status === 'Success' ||
        detail?.includes(content?.successfullyUnlinked)
      ) {
        setCanUnlink(false);
        setLinkageStatusText(
          content?.linkedSubTitle || 'Your card is unlinked.'
        );
        setShowSuccessModal(true);
        dispatch(bankAccountDetailRequest({ accId: accountId }));
        dispatch(
          fetchRewardAccountRequest({ user_id: accountId.replace(/^0+/, '') })
        );
      }
      //   else if (
      //     error?.status !== 'Success' ||
      //     error?.detail?.includes('Error')
      //   )
      else if (error) {
        setIsUnlinkError(true);
      }
    }
  }, [isUnlinking, loading, linkingStatus, status, detail]);

  const { customerId } = useSelector((state: RootState) => state.user);

  const handleConfirm = () => {
    setShowConfirmModal(false);

    if (rciAccountDetails?.bankAccountResponse) {
      setIsUnlinking(true);
      const payload = {
        ban: rciAccountDetails?.bankAccountResponse?.ban,
        accountId: accountId,
        customerId: customerId,
      };
      console.log(payload, 'payload');
      //  setShowSuccessModal(true);
      // setIsUnlinkError(true);
      dispatch(
        unlinkAccountRequest({
          ban: rciAccountDetails?.bankAccountResponse?.ban,
          accountId: accountId,
          customerId: customerId,
        })
      );
    } else {
      console.error('Missing required BAN information for unlinking');
    }
  };

  //--end--

  // Function to handle logout
  const logout = async () => {
    //const deviceId = localStorage.getItem('deviceId');

    const userData = {
      username: userName,
      deviceId: deviceId,
      channel: getChannelId,
      flow: 'PATH_SIGNOUT_API',
    };
    // resetInputValues
    const data = {
      apiName: 'sign_out',
      data: userData,
      accountId: accountId,
    };
    dispatch(signOutRequest(data));
    // setTimeout(() => {
    // dispatch(resetRequest(null));
    // dispatch(resetOffersSlice());
    // dispatch(resetManageAlertsSlice());
    // dispatch(resetContactInfoSlice());
    // dispatch(resetValidatePasscodeSlice());
    // localStorage.removeItem('hasDismissedOffer');
    // ls.remove('user');
    // ls.remove('tokens');
    // if (localStorage.getItem('language')) {
    //   const lang = localStorage.getItem('language') == 'fr' ? 'fr' : 'en';
    //   navigate(`/sign-in?locale=${lang}`);
    // } else {
    //   navigate('/sign-in');
    // }
    // }, 2000);
  };
  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'en-US';
    setSelectedLanguage(storedLanguage);
  }, []);

  const handleLanguageChange = (e: any) => {
    const newLanguage = e.target.value;
    setSelectedLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    console.log(`Language changed to: ${newLanguage}`);

    navigate(0);
  };
  return (
    <>
      <header
        className="bg-primary-red text-white flex md:justify-between md:flex-row items-center p-4 justify-center flex-row-reverse"
        role="banner"
      >
        <div className="flex items-center" aria-label="Company Logo">
          <img
            src={assets?.rb_logo_white}
            alt={contentfulData?.headerLogoAltText || 'Company Logo'}
            className="w-[208px] h-[26px]"
          />
        </div>

        <div
          className="hidden md:flex items-center space-x-4"
          aria-label="Header Controls"
        >
          <div role="group" aria-labelledby="language-select-label">
            <label
              id="language-select-label"
              htmlFor="language-select"
              className="sr-only"
            >
              {rb_contact_information.editContactInfo.prefLanguage.prefLang ||
                'Preferred Language'}
            </label>
            <select
              id="language-select"
              className="bg-primary-red text-white px-2 py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
              value={selectedLanguage}
              onChange={handleLanguageChange}
              aria-describedby="language-select-label"
            >
              <option className="bg-white text-black" value="en-US">
                {contentfulData?.englishTitle || 'English'}
              </option>
              <option className="bg-white text-black" value="fr">
                {contentfulData?.frenchTitle || 'Français'}
              </option>
            </select>
          </div>

          <button
            id="account-div"
            className="bg-primary-red text-white rounded px-4 py-1 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white cursor-pointer"
            onClick={() => navigate('/my-profile')}
            aria-label="My Profile"
          >
            {contentSideNav?.rb_navigation?.moreMenu?.my_profile ||
              'My Profile'}
          </button>

          {/* Sign Out Button */}
          <button
            type="button"
            className="py-1 px-4 border text-white"
            onClick={logout}
            aria-label="Sign Out"
          >
            {contentfulData?.signOutCtaTitle || 'Sign Out'}
          </button>
        </div>

        <div className="md:hidden flex items-center absolute left-5">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? 'Close Menu' : 'Open Menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
            className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <svg
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
            >
              <path
                d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </header>

      {isMobileMenuOpen && (
        <MobileSideMenu
          isMenuOpenValue={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          contentfulData={contentSideNav}
          featureFlaggingData={featureFlaggingData}
          setShowFeatureFlagMessage={setShowFeatureFlagMessage}
          logoutFunc={logout}
          isLinkAcc={isLinkAcc}
          isAccountRestricted={isAccountRestricted}
          assets={assets}
          derogatoryData={derogatoryData}
          isEppVisible={isEppVisible}
          isPasskeyRegistered={isPasskeyRegistered}
          setUnlinkAccountPopup={setUnlinkAccountPopup}
        />
      )}

      {/* //unlink account */}
      {isMobileMenuOpen && isUnlinkAccountPopup && (
        <UnlinkRogersBenefits
          isUnlinkAccountPopup={isUnlinkAccountPopup}
          setUnlinkAccountPopup={setUnlinkAccountPopup}
          setShowConfirmModal={setShowConfirmModal}
          setShowSuccessModal={setShowSuccessModal}
          setNextLinkageDate={setNextLinkageDate}
          nextLinkageDate={nextLinkageDate}
          setLinkageStatusText={setLinkageStatusText}
          setIsUnlinkError={setIsUnlinkError}
        />
      )}

      <CommanModal
        isOpen={showConfirmModal}
        onClose={handleCancel}
        onExtraButtonClick={handleConfirm}
        jsxContent={
          <div className="text-center">
            <div className="mb-4 text-[#1F1F1F] text-[18px] font-medium ">
              {content?.confirmationPopupTitle}
            </div>
            <p className="mb-[40px]">{''}</p>
          </div>
        }
        buttonText={content?.btnConfirmationPopupCancel}
        extraButtonText={
          loading ? 'Loading...' : content?.btnConfirmationPopupConfirm
        }
        buttonClassName="flex-col-reverse"
        closeIcon={false}
      />

      {isMobileMenuOpen && showSuccessModal && (
        <SuccessModel
          isOpen={showSuccessModal}
          title={linkageStatusText}
          subTitle={
            content?.successPopupSubTitle + nextLinkageDate ||
            nextLinkAttemptDate ||
            ''
          }
          successIcon={true}
          closeModal={handleOk}
          errorIcon={false}
        />
      )}

      {isMobileMenuOpen && isUnlinkError && (
        <SuccessModel
          isOpen={isUnlinkError}
          title={eligibleContent?.roamLikeHomeError?.title}
          subTitle={eligibleContent?.roamLikeHomeError?.detail}
          successIcon={false}
          closeModal={handleOk}
          errorIcon={false}
        />
      )}
    </>
  );
};

export default Header;
